import { Stack, Typography } from "@mui/material";
import { green, grey, red } from "@mui/material/colors";
import dayjs, { Dayjs } from "dayjs";
import { StatusDot } from "../../../components";
import { DailyInspection } from "../../../models";

function isCompleted(dailyInspection: DailyInspection | undefined): boolean {
  if (!dailyInspection?.inspectionCompletedCentralDateTime) return false;
  return dayjs(dailyInspection.inspectionCompletedCentralDateTime).year() > 2000;
}

function buildCompletedText(dailyInspection: DailyInspection): string {
  const completedAt = dayjs(dailyInspection.inspectionCompletedCentralDateTime);
  const inspectionDate = dailyInspection?.inspectionCentralDateTime ? dayjs(dailyInspection.inspectionCentralDateTime) : null;

  const isSameDay = inspectionDate && completedAt.format("YYYY-MM-DD") === inspectionDate.format("YYYY-MM-DD");

  const timeStr = completedAt.format("h:mm A");

  if (isSameDay) {
    return `Inspected at ${timeStr}`;
  }

  const dateStr = completedAt.format("M/D");
  return `Inspected ${dateStr} at ${timeStr}`;
}

export function CalendarDailyInspectionEvent(props: { inspectionCentralDate: Dayjs; dailyInspection: DailyInspection | undefined; today: Dayjs }) {
  const { inspectionCentralDate, dailyInspection, today } = props;

  const completed = isCompleted(dailyInspection);
  const isPastOrToday = !inspectionCentralDate.isAfter(today, "day");

  let dotColor: string;
  let textColor: string;
  let label: string;

  if (completed) {
    dotColor = green[500];
    textColor = "inherit";
    label = buildCompletedText(dailyInspection!);
  } else if (isPastOrToday) {
    dotColor = red[500];
    textColor = red[500];
    label = "Inspection incomplete";
  } else {
    dotColor = grey[500];
    textColor = "inherit";
    label = "Inspection incomplete";
  }

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <StatusDot color={dotColor} />
      <Typography variant="caption" sx={{ color: textColor }}>
        {label}
      </Typography>
    </Stack>
  );
}
